import http from '@core/fetch'

export default {
  businessSchool: body =>
    http('/p/wedding/index.php/Admin/APIBusinessCollege/detail', { body })
}
